import {
  FETCH_LEAVES, FETCH_LEAVES_SUCCESS, FETCH_LEAVES_FAILURE,
  CREATE_LEAVE, CREATE_LEAVE_SUCCESS, CREATE_LEAVE_FAILURE,
  UPDATE_LEAVE, UPDATE_LEAVE_SUCCESS, UPDATE_LEAVE_FAILURE,
  DELETE_LEAVE, DELETE_LEAVE_SUCCESS, DELETE_LEAVE_FAILURE
} from "./actionTypes";

export const fetchLeaves = (unitId) => ({ type: FETCH_LEAVES, payload: { unitId } });
export const fetchLeavesSuccess = (leaves) => ({ type: FETCH_LEAVES_SUCCESS, payload: leaves });
export const fetchLeavesFailure = (error) => ({ type: FETCH_LEAVES_FAILURE, payload: error });

export const createLeave = (formData) => ({ type: CREATE_LEAVE, payload: {formData} });
export const createLeaveSuccess = (leave) => ({ type: CREATE_LEAVE_SUCCESS, payload: leave });
export const createLeaveFailure = (error) => ({ type: CREATE_LEAVE_FAILURE, payload: error });

export const updateLeave = (leave) => ({ type: UPDATE_LEAVE, payload: leave });
export const updateLeaveSuccess = (leave) => ({ type: UPDATE_LEAVE_SUCCESS, payload: leave });
export const updateLeaveFailure = (error) => ({ type: UPDATE_LEAVE_FAILURE, payload: error });

export const deleteLeave = (id) => ({ type: DELETE_LEAVE, payload: id });
export const deleteLeaveSuccess = (id) => ({ type: DELETE_LEAVE_SUCCESS, payload: id });
export const deleteLeaveFailure = (error) => ({ type: DELETE_LEAVE_FAILURE, payload: error });